import { combineReducers } from 'redux-immutable';
import serviceProvider     from './serviceProvider';


export default combineReducers({serviceProvider});


// WEBPACK FOOTER //
// ./src/reducers/registration/index.js